import { UserPaths } from '../app/modules/user/user-paths';
import { IConfig } from './IConfig';

const baseUrl = window.location.origin;

export const config: IConfig = {
  appName: 'yoUR B!noculars',
  defaultRoute: `/${UserPaths.home}`,
  authServiceURL: 'https://dev.yourbinoculars.com/authservice/api/v1',
  userServiceURL: 'https://dev.yourbinoculars.com/userservice/api/v1',
  adminServiceURL: 'https://dev.yourbinoculars.com/adminservice/api/v1',
  mediaDeliveryService:
    'https://dev.yourbinoculars.com/mediadeliveryservice/api/v1/media',
  contentManagementServiceUrl:
    'https://dev.yourbinoculars.com/contentmanagementservice/api/v1/content',
  trackingServiceUrl:
    'https://dev.yourbinoculars.com/trackingservice/api/v1/tracker',
  accessKey: 'test-key-web',
  clientType: 'Web',
  iosClientType: 'IOS',
  appleClientId: 'com.gci.asher.android.dev',
  authRedirectUri: `${baseUrl}`,
  razorPayKey: 'rzp_test_R9yEIpObVZhaXE',
  reCAPTCHA_site_key: '6LdOA7wsAAAAACrsFdCBltC51RBze89NtsDO0mRq',
  maxUserBooksShown: 15,
  layoutBuilderUrl: 'https://dev.yourbinoculars.com/layoutbuilder',
};
